import { Button, Form, Input, InputNumber, message, Modal, Space, Spin, Table, TablePaginationConfig } from "antd";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useId24 } from "../../../drivers/id24/Id24Provider";
import { CustomerUrlService } from "../../../api/customer-url.service";
import dayjs from "dayjs";
import "dayjs/locale/th";
import buddhistEra from "dayjs/plugin/buddhistEra";
import { CreateCustomerUrlDto } from "../../../types/customer-url.type";
import { ColumnsType } from "antd/es/table";
import { useForm } from "antd/es/form/Form";
import { loadAppConfig } from "../../../configs/app-config";
dayjs.extend(buddhistEra);
dayjs.locale("th");

export const ActivityListGenerateQr: React.FC = (): React.ReactElement => {
  const { id24Axios } = useId24();
  const apiBaseUrl = id24Axios(loadAppConfig().REACT_APP_API_BASE_URL);
  const { agendaId } = useParams<{ agendaId: string }>();
  const [loading, setLoading] = useState<boolean>(true);
  const [dataSource, setDataSource] = useState<{ count: number; data: CreateCustomerUrlDto[] }>({ count: 0, data: [] });
  const [pagination, setPagination] = useState<{ current: number; pageSize: number }>({ current: 1, pageSize: 10 });
  const [isModalCreate, setIsModalCreate] = useState<{ title?: "create" | "update" | undefined; status: boolean }>({
    title: undefined,
    status: false,
  });
  const [form] = useForm();
  const columns: ColumnsType<CreateCustomerUrlDto> = [
    {
      title: "No.",
      dataIndex: "id",
      key: "id",
      width: "5%",
      render: (value, record, index) => index + 1 + (pagination.current - 1) * pagination.pageSize,
    },
    {
      key: "customerNumber",
      title: "Customer Number",
      dataIndex: "customerNumber",
      width: "30%",
    },
    {
      key: "customerName",
      title: "Customer Name",
      dataIndex: "customerName",
      width: "30%",
    },
    {
      key: "limit",
      title: "Limit",
      dataIndex: "limit",
      width: "10%",
    },
    {
      key: "customerNumber",
      title: "Customer Url",
      dataIndex: "customerNumber",
      width: "10%",
      render: (value: string) => (
        <Button
          size="small"
          onClick={() => {
            onCoppy(`${window.location.origin}/activity-agenda/activity-step/econnect-2025/partners/${value}`);
            message.success("Copy to Clipboard");
          }}
        >
          Copy
        </Button>
      ),
    },
    {
      key: "id",
      title: "Action",
      dataIndex: "id",
      width: "20%",
      render: (value: number, record: CreateCustomerUrlDto) => (
        <Space>
          <Button type="primary" size="small" onClick={() => optionModal("update", record)}>
            Update
          </Button>
          <Button type="primary" danger size="small" onClick={() => onDelete(value)}>
            Delete
          </Button>
        </Space>
      ),
    },
  ];

  useEffect(() => {
    if (loading) featchData();
  }, [loading]);

  const featchData = async () => {
    const skip = (Number(pagination.current) - 1) * Number(pagination.pageSize);
    const take = Number(pagination.pageSize);
    try {
      if (agendaId) {
        const result = await CustomerUrlService(apiBaseUrl).getAll(agendaId, skip, take);
        setDataSource(result);
        setLoading(false);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const onChangeTable = (pagination: TablePaginationConfig) => {
    const { current, pageSize } = pagination;
    setPagination({ current: current || 1, pageSize: pageSize || 10 });
    setLoading(true);
  };

  const onAction = async (event: { id?: number; customerName: string; customerNumber: string; limit: string }) => {
    try {
      if (!agendaId) return;
      const data = {
        customerName: event.customerName,
        customerNumber: event.customerNumber,
        limit: event.limit,
        Agenda: agendaId,
      };

      if (isModalCreate.title === "create") {
        await CustomerUrlService(apiBaseUrl).create(data);
      } else {
        const id = event.id;
        if (id) {
          const result = await CustomerUrlService(apiBaseUrl).update(id, data);
          if (!result) return;
        }
      }
      message.success("success");
      setLoading(true);
      form.resetFields();
      setIsModalCreate({ status: false });
    } catch (err) {
      console.error(err);
      setIsModalCreate({ status: false });
    }
  };

  const onDelete = async (value: number) => {
    try {
      const result = await CustomerUrlService(apiBaseUrl).delete(value);
      if (result) {
        message.success("success");
        setLoading(true);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const onCoppy = async (value: string) => {
    try {
      await navigator.clipboard.writeText(value);
    } catch (err) {
      console.error("Failed to copy text:", err);
    }
  };

  const optionModal = async (title: "create" | "update", value?: CreateCustomerUrlDto) => {
    if (title === "update") {
      form.setFieldsValue(value);
    }
    console.log(title);
    setIsModalCreate({ title: title, status: true });
  };

  return (
    <Spin tip="Loading...." spinning={loading}>
      <div className=" flex justify-end pb-2">
        <Button type="primary" onClick={() => optionModal("create")}>
          Add
        </Button>
      </div>
      <Table
        size="small"
        loading={loading}
        dataSource={dataSource.data}
        columns={columns}
        rowKey={`id`}
        onChange={onChangeTable}
        pagination={{
          ...pagination,
          defaultPageSize: 10,
          total: dataSource.count,
          showSizeChanger: true,
        }}
      />
      <Modal
        title={`${isModalCreate.title?.toUpperCase()} CustomerUrl`}
        open={isModalCreate.status}
        footer={[]}
        onCancel={() => {
          setIsModalCreate({ status: false });
          form.resetFields();
        }}
      >
        <Form form={form} layout="vertical" onFinish={onAction}>
          <Form.Item name={`id`} hidden>
            <Input />
          </Form.Item>
          <Form.Item
            name={`customerNumber`}
            label="Customer Number"
            rules={[
              {
                required: true,
                message: "Please fill in your Customer Number!",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name={`customerName`}
            label="Customer Name"
            rules={[
              {
                required: true,
                message: "Please fill in your Customer Name!",
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name={`limit`}
            label="Limit User"
            rules={[
              {
                required: true,
                message: "Please fill in your Limit User!",
              },
            ]}
          >
            <InputNumber min={1} />
          </Form.Item>
          <Form.Item>
            <Space className="flex justify-end">
              <Button
                onClick={() => {
                  setIsModalCreate({ status: false });
                  form.resetFields();
                }}
              >
                ยกเลิก
              </Button>
              <Button htmlType="submit" type="primary">
                ตกลง
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>
    </Spin>
  );
};
